import type {ThesaurusId, ThesaurusMap} from 'services/thesaurus/types';
import {getThesaurusMaps} from 'services/thesaurus';
import type {MultiThesaurusMaps} from '../types';

export const getMultiThesaurusMaps = (thesauruses: ThesaurusMap) => {
  return (Object.keys(thesauruses) as ThesaurusId[]).reduce<MultiThesaurusMaps>(
    (acc, id) => ({
      ...acc,
      [id]: getThesaurusMaps(thesauruses[id]!),
    }),
    {},
  );
};
